module.exports = __webpack_public_path__ + "assets/retina_L3ParallelDetailed.11f774f5b9605d8bdf36241e851e0366.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/2x/retina_L3ParallelDetailed.png
// module id = 682
// module chunks = 0